import React, { useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import CustomSelect from "./CustomSelect";
import {
  FilterWrapper,
  FilterLabel
} from "containers/impact-report/index.styled";
import { generateAgencyOptions } from "utils/optionGenerators";

const AgencySelect = ({
  communityRequests,
  selectedAgency,
  onAgencyChange
}) => {
  const { t } = useTranslation();

  const agencyOptions = useMemo(
    () => generateAgencyOptions(communityRequests),
    [communityRequests]
  );

  const handleChange = useCallback(
    option => {
      const values = option ? option.map(opt => opt.value) : [];
      onAgencyChange(values);
    },
    [onAgencyChange]
  );

  // Convert selectedAgency array to option format for CustomSelect
  const selectedValue = agencyOptions.filter(opt =>
    selectedAgency.includes(opt.value)
  );

  return (
    <FilterWrapper>
      <FilterLabel>
        {t("impactReport.communityRequests.agencyNameLabel")}
      </FilterLabel>
      <CustomSelect
        value={selectedValue}
        onChange={handleChange}
        options={agencyOptions}
        placeholder={t("impactReport.communityRequests.agencyNamePlaceholder")}
        isMulti
        showFooter
        isSearchable
        isDisabled={!agencyOptions.length}
      />
    </FilterWrapper>
  );
};

AgencySelect.propTypes = {
  communityRequests: PropTypes.array.isRequired,
  selectedAgency: PropTypes.arrayOf(PropTypes.string).isRequired,
  onAgencyChange: PropTypes.func.isRequired
};

export default AgencySelect;
